module.exports = "<wav-studios-header></wav-studios-header>\n\n<router-outlet></router-outlet>\n\n<wav-studios-header></wav-studios-header>\n\n<video #homeVideo autoplay=\"\" loop=\"true\" muted=\"true\" playsinline=\"true\" id=\"video-background\" src=\"https://firebasestorage.googleapis.com/v0/b/wav-studios.appspot.com/o/ocean_waves2.mp4?alt=media&token=9a946435-638c-4ae7-9f21-8704fd71e837\"></video>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 5xMp
// module chunks = 1